<div class="modalContainer">
    <div class="modal-header">
        <div class="modal-title">Interest Rate and Risk Range
            <div class="modal-sub-title">
                Indicative interest rate and sub-product allocation basis the risk ranges selected
            </div>
        </div>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12">
                <section class="table-wrapper">
                    <table class="table table-hover">
                        <thead class="table-head">
                            <tr class="th-row">
                                <th colspan="3" scope="col" class="bg-grey th-data p-4 font-weight-normal">Risk
                                    Range Selection Combination</th>
                                <th scope="col" class="bg-grey p-4 th-data font-weight-normal">Allocation</th>
                                <th scope="col" class="bg-grey p-4 th-data font-weight-normal">Interest Rate
                                </th>
                            </tr>
                        </thead>
                        <tbody class="table-body">
                            <tr class="tb-row">
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">Low Risk (A1 -
                                                A6)</p>
                                            <small class="text-color-darker-grey">10.99% to 15.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">Medium Risk
                                                (B1 - B6)</p>
                                            <small class="text-color-darker-grey">16.99% to 21.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">High Risk (C1
                                                - C6)</p>
                                            <small class="text-color-darker-grey">22.99% to 27.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-9 mr-0 d-flex">
                                            <p class="font-weight-bold m-0 medium-big-text text-color-black">
                                                {{matDialogData.selectedProduct}}</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-success font-weight-bold m-0 medium-big-text">
                                                upto {{matDialogData.riskScore[matDialogData.selectedProduct]["9"] || DEFAULT_PRODUCT_CATEGORY_VARIANT[matDialogData.selectedProduct]["9"] }}% p.a
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="tb-row">
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">Low Risk (A1 -
                                                A6)</p>
                                            <small class="text-color-darker-grey">10.99% to 15.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">Medium Risk
                                                (B1 - B6)</p>
                                            <small class="text-color-darker-grey">16.99% to 21.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/close_red_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-darker-grey font-weight-bold m-0">High Risk (C1
                                                - C6)</p>
                                            <small class="text-color-darker-grey">22.99% to 27.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-9 mr-0 d-flex">
                                            <p class="font-weight-bold m-0 medium-big-text text-color-black">
                                                {{matDialogData.selectedProduct}}</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-success font-weight-bold m-0 medium-big-text">
                                                upto {{matDialogData.riskScore[matDialogData.selectedProduct]["4"] || DEFAULT_PRODUCT_CATEGORY_VARIANT[matDialogData.selectedProduct]["4"]}}% p.a
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="tb-row">
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">Low Risk (A1 -
                                                A6)</p>
                                            <small class="text-color-darker-grey">10.99% to 15.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/close_red_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-darker-grey font-weight-bold m-0">Medium Risk
                                                (B1 - B6)</p>
                                            <small class="text-color-darker-grey">16.99% to 21.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">High Risk (C1
                                                - C6)</p>
                                            <small class="text-color-darker-grey">22.99% to 27.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-9 mr-0 d-flex">
                                            <p class="font-weight-bold m-0 medium-big-text text-color-black">
                                                {{matDialogData.selectedProduct}}</p>
                                            <small class="extra-small-text font-weight-bold">C1</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-success font-weight-bold m-0 medium-big-text">
                                                upto {{matDialogData.riskScore[matDialogData.selectedProduct]["6"] || DEFAULT_PRODUCT_CATEGORY_VARIANT[matDialogData.selectedProduct]["6"]}}% p.a
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="tb-row">
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/close_red_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-darker-grey font-weight-bold m-0">Low Risk (A1
                                                - A6)</p>
                                            <small class="text-color-darker-grey">10.99% to 15.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">Medium Risk
                                                (B1 - B6)</p>
                                            <small class="text-color-darker-grey">16.99% to 21.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-2 mr-2">
                                            <img alt="tick_img"
                                                src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                        </div>
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-color-finzy-blue font-weight-bold m-0">High Risk (C1
                                                - C6)</p>
                                            <small class="text-color-darker-grey">22.99% to 27.99%</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-9 mr-0 d-flex">
                                            <p class="font-weight-bold m-0 medium-big-text text-color-black">
                                                {{matDialogData.selectedProduct}}</p>
                                            <small class="extra-small-text font-weight-bold">C2</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="tb-data pr-0">
                                    <div class="row">
                                        <div class="col-sm-9 mr-0">
                                            <p class="text-success font-weight-bold m-0 medium-big-text">
                                                upto {{matDialogData.riskScore[matDialogData.selectedProduct]["8"] || DEFAULT_PRODUCT_CATEGORY_VARIANT[matDialogData.selectedProduct]["8"]}}% p.a
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>
            <div class="col-12">
                <!-- MOBILE SCREEN PORTION STARTS -->
                <article class="responsive-table bg-white">
                    <mat-card class="mb-4 px-0" style="border: 1px solid #eee; border-radius: 10px; box-shadow: none; transition: none;">
                        <mat-card-header>
                            <mat-card-subtitle class="font-weight-bold text-color-black">Risk Range Selection Combination</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="row">
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">Medium Risk(A1 - A6)</p>
                                        <small class="text-color-darker-grey">10.99% to 15.99%</small>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">Medium Risk(B1 - B6)</p>
                                        <small class="text-color-darker-grey">16.99% to 21.99%</small>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">High Risk (C1 - C6)</p>
                                        <small class="text-color-darker-grey">22.99% to 27.99%</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex justify-content-between px-5">
                                <div class="col-xs-6 bg-grey p-3 mr-3 min-content">
                                    <p class="m-0">Allocation</p>
                                    <p class="font-weight-bold">{{matDialogData.selectedProduct}}</p>
                                </div>

                                <div class="col-xs-6 bg-grey p-3 min-content">
                                    <p class="m-0">Interest Rate</p>
                                    <p class="font-weight-bold"> 
                                        upto {{matDialogData.riskScore[matDialogData.selectedProduct]["9"] || DEFAULT_PRODUCT_CATEGORY_VARIANT[matDialogData.selectedProduct]["9"]}}% p.a
                                    </p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="mb-4 px-sm-4 px-0" style="border: 1px solid #eee; border-radius: 10px; box-shadow: none; transition: none;">
                        <mat-card-header>
                            <mat-card-subtitle class="font-weight-bold text-color-black">Risk Range Selection Combination</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="row">
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">Low Risk (A1 - A6)</p>
                                        <small class="text-color-darker-grey">10.99% to 15.99%</small>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">Medium Risk(B1 - B6)</p>
                                        <small class="text-color-darker-grey">16.99% to 21.99%</small>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/close_red_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">High Risk (C1 - C6)</p>
                                        <small class="text-color-darker-grey">22.99% to 27.99%</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex justify-content-between px-5">
                                <div class="col-xs-6 bg-grey p-3 mr-3 min-content">
                                    <p class="m-0">Allocation</p>
                                    <p class="font-weight-bold">{{matDialogData.selectedProduct}}</p>
                                </div>

                                <div class="col-xs-6 bg-grey p-3 min-content">
                                    <p class="m-0">Interest Rate</p>
                                    <p class="font-weight-bold">
                                        upto {{matDialogData.riskScore[matDialogData.selectedProduct]["4"] || DEFAULT_PRODUCT_CATEGORY_VARIANT[matDialogData.selectedProduct]["4"]}}% p.a
                                    </p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="mb-4 px-sm-4 px-0" style="border: 1px solid #eee; border-radius: 10px; box-shadow: none; transition: none;">
                        <mat-card-header>
                            <mat-card-subtitle class="font-weight-bold text-color-black">Risk Range Selection Combination</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="row">
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">Low Risk (A1 - A6)</p>
                                        <small class="text-color-darker-grey">10.99% to 15.99%</small>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/close_red_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">Medium Risk(B1 - B6)</p>
                                        <small class="text-color-darker-grey">16.99% to 21.99%</small>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">High Risk (C1 - C6)</p>
                                        <small class="text-color-darker-grey">22.99% to 27.99%</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex justify-content-between px-5">
                                <div class="col-xs-6 bg-grey p-3 mr-3 min-content">
                                    <p class="m-0">Allocation</p>
                                    <p class="font-weight-bold d-flex">{{matDialogData.selectedProduct}}
                                        <small class="extra-small-text font-weight-bold mt-1">C1</small>
                                    </p>
                                </div>

                                <div class="col-xs-6 bg-grey p-3 min-content">
                                    <p class="m-0">Interest Rate</p>
                                    <p class="font-weight-bold">
                                        upto {{matDialogData.riskScore[matDialogData.selectedProduct]["6"] || DEFAULT_PRODUCT_CATEGORY_VARIANT[matDialogData.selectedProduct]["6"]}}% p.a
                                    </p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="px-sm-4 px-0" style="border: 1px solid #eee; border-radius: 10px; box-shadow: none; transition: none;">
                        <mat-card-header>
                            <mat-card-subtitle class="font-weight-bold text-color-black">Risk Range Selection Combination</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="row">
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/close_red_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">Low Risk (A1 - A6)</p>
                                        <small class="text-color-darker-grey">10.99% to 15.99%</small>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">Medium Risk(B1 - B6)</p>
                                        <small class="text-color-darker-grey">16.99% to 21.99%</small>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-xs-10 p-0 d-flex justify-content-sm-center align-items-center mb-4 ml-4">
                                    <div class="col-sm-2 col-xs-2">
                                        <img alt="tick_img" src="../../../../../../assets/images/rbi-compliance/tick_green_bg_gray.svg" />
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="text-color-finzy-blue font-weight-bold m-0">High Risk (C1 - C6)</p>
                                        <small class="text-color-darker-grey">22.99% to 27.99%</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex justify-content-between px-5">
                                <div class="col-xs-6 bg-grey p-3 mr-3 min-content">
                                    <p class="m-0">Allocation</p>
                                    <p class="font-weight-bold d-flex">{{matDialogData.selectedProduct}}
                                        <small class="extra-small-text font-weight-bold mt-1">C2</small>
                                    </p>
                                </div>

                                <div class="col-xs-6 bg-grey p-3 min-content">
                                    <p class="m-0">Interest Rate</p>
                                    <p class="font-weight-bold">
                                        upto {{matDialogData.riskScore[matDialogData.selectedProduct]["8"] || DEFAULT_PRODUCT_CATEGORY_VARIANT[matDialogData.selectedProduct]["8"]}}% p.a
                                    </p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </article>
            </div>
        </div>
    </div>

    <div class="modal-footer mb-4">
        <button (click)="decline()" type="button" mat-flat-button class="primary no-text-transform"
            [mat-dialog-close]="true" cdkFocusInitial style="height: 55px;">{{matDialogData.buttonText}}</button>
    </div>
</div>